module.exports = __webpack_public_path__ + "images/feature/20160129_02-ffdf77717820c0f753e3c6b361cfddf7.png";